import { render, staticRenderFns } from "./TitleUnderline.vue?vue&type=template&id=d74889f6&scoped=true&"
import script from "./TitleUnderline.vue?vue&type=script&lang=js&"
export * from "./TitleUnderline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74889f6",
  null
  
)

export default component.exports